import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { SharedService } from 'src/app/services/SharedService/shared.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { TermoUsoService } from 'src/app/services/TermoUsoService/termoUso.service';
import Swal from 'sweetalert2';

type IType = 'success' | 'error' | 'warning';

@Component({
  selector: 'app-login-usuario',
  templateUrl: './login-usuario.component.html',
  styleUrls: ['./login-usuario.component.scss']
})
export class LoginUsuarioComponent implements OnInit {
  private subscription$ = new Subscription();
  loginForm = this.initializeLoginForm();
  activeRoute: string = '';
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private sharedService: SharedService,
    private swalAlert: SwalAlertService,
    private termoUsoService: TermoUsoService,
    private appExport: AppExportBase64
  ) {}

  ngOnInit(): void {
    localStorage.clear();
    const linkUso = document.getElementById('link-termo-uso');
    const linkConsentimento = document.getElementById(
      'link-termo-consentimento'
    );

    if (linkUso) {
      linkUso.addEventListener('click', event => {
        event.preventDefault();
        this.viewTermoUso(1);
      });
    }

    if (linkConsentimento) {
      linkConsentimento.addEventListener('click', event => {
        event.preventDefault();
        this.viewTermoUso(2);
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private initializeLoginForm() {
    return this.fb.group({
      TX_MAIL_EXTR: [
        '',
        {
          nonNullable: true,
          validators: [
            Validators.required,
            Validators.email,
            Validators.pattern(
              '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
            )
          ]
        }
      ],
      TX_SENH_EXTR: [
        '',
        { nonNullable: true, validators: [Validators.required] }
      ]
    });
  }

  viewTermoUso(tipoTermo: number) {
    this.termoUsoService.GetLastTermoVersionByTipo(tipoTermo).subscribe({
      next: response => {
        this.appExport.guiaPdf(response.File.Base64Content);
      }
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const { TX_MAIL_EXTR, TX_SENH_EXTR } = this.loginForm.value;
      this.isLoading = true;

      if (
        typeof TX_MAIL_EXTR === 'string' &&
        typeof TX_SENH_EXTR === 'string'
      ) {
        this.subscription$.add(
          this.authService.login(TX_MAIL_EXTR, TX_SENH_EXTR).subscribe({
            next: () => {
              this.isLoading = false;
              if (this.authService.isTokenValid) {
                this.router.navigate(['home']);
                return;
              }
            },
            error: error => {
              this.isLoading = false;

              if (error.status === 401) {
                this.showSwal('Credenciais inválidas.', 'warning');
              } else {
                this.showSwal(
                  'Verifique o email e/ou senha e tente novamente.',
                  'warning'
                );
              }
            },
            complete: () => {
              this.isLoading = false;
            }
          })
        );
      } else {
        this.isLoading = false;
        this.showSwal('Email ou senha inválidos.', 'warning');
      }
    } else {
      this.isLoading = false;
      this.showSwal('Preencha os campos obrigatórios.', 'warning');
    }
  }

  showSwal(message: string, type: IType) {
    const typeTitle = {
      error: 'Error!',
      warning: 'Atenção',
      success: 'Sucesso'
    };

    this.swalAlert.showAlert(
      typeTitle[type],
      message,
      type,
      false,
      false,
      undefined
    );
  }

  goTo(route: string) {
    this.sharedService.setIsEmpresa(true);
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }
}
